export default {
  pageNotFound_error: '{{log.user.name}} tentou acessar uma página inexistente',

  mutationUpsertUser: '{{log.user.name}} salvou o usuário: {{log.entity.name}}',

  createUser: '{{log.user.name}} criou o usuário: {{log.entity.name}}',
  updateUser: '{{log.user.name}} atualizou o usuário: {{log.entity.name}}',
  createUser_error: '{{log.user.name}} recebeu um erro ao cadastrar o usuário: {{log.entity.name}}',
  updateUser_error: '{{log.user.name}} recebeu um erro ao atualizar o usuário: {{log.entity.name}}',
  removeUsers: '{{log.user.name}} removeu alguns usuários',
  mutationRemoveUsers: '{{log.user.name}} removeu alguns usuários',
  mutationRemoveUsers_error: '{{log.user.name}} recebeu um erro ao remover alguns usuários',
  removeUsers_error: '{{log.user.name}} recebeu um erro ao remover alguns usuários',

  mutationUpsertTrigger: '{{log.user.name}} salvou um gatilho',
  mutationRemoveTriggers: '{{log.user.name}} removeu alguns gatilhos',
  mutationRemoveTriggers_error: '{{log.user.name}} recebeu um erro ao remover alguns gatilhos',

  createChecklist: '{{log.user.name}} criou o questionário: {{log.entity.name}}',
  updateChecklist: '{{log.user.name}} atualizou o questionário: {{log.entity.name}}',
  createChecklist_error: '{{log.user.name}} recebeu um erro ao salvar o questionário: {{log.entity.name}}',
  updateChecklist_error: '{{log.user.name}} recebeu um erro ao salvar o questionário: {{log.entity.name}}',
  removeChecklists: '{{log.user.name}} removeu alguns questionários',
  removeChecklists_error: '{{log.user.name}} recebeu um erro ao remover alguns questionários',

  createServiceOrder: '{{log.user.name}} criou a atividade: {{log.entity.name}}',
  updateServiceOrder: '{{log.user.name}} atualizou a atividade: {{log.entity.name}}',
  mutationUpsertServiceOrder: '{{log.user.name}} salvou a atividade: {{log.entity.name}}',
  createServiceOrder_error: '{{log.user.name}} recebeu um erro ao salvar a atividade: {{log.entity.name}}',
  updateServiceOrder_error: '{{log.user.name}} recebeu um erro ao salvar a atividade: {{log.entity.name}}',
  removeServiceOrders: '{{log.user.name}} removeu algumas atividades',
  removeServiceOrders_error: '{{log.user.name}} recebeu um erro ao remover algumas atividades',
  saveServiceOrderReplies: '{{log.user.name}} alterou as respostas da atividade: {{log.entity.name}}',
  saveServiceOrderReplies_error:
    '{{log.user.name}} recebeu um erro ao alterar as respostas da atividade: {{log.entity.name}}',

  createActionPlan: '{{log.user.name}} criou um plano de ação',
  createActionPlan_error: '{{log.user.name}} recebeu um erro ao criar um plano de ação',

  updateServiceOrderStatus_execution: '{{log.user.name}} atualizou o status da atividade para execução',
  updateServiceOrderStatus_execution_error:
    '{{log.user.name}} recebeu um erro ao atualizar o status da atividade para execução',
  updateServiceOrderStatus_pause: '{{log.user.name}} atualizou o status da atividade para pausada',
  updateServiceOrderStatus_pause_error:
    '{{log.user.name}} recebeu um erro ao atualizar o status da atividade para pausada',
  updateServiceOrderStatus_completed: '{{log.user.name}} atualizou o status da atividade para concluída',
  updateServiceOrderStatus_completed_error:
    '{{log.user.name}} recebeu um erro ao atualizar o status da atividade para concluída',
  updateServiceOrderStatus_approved: '{{log.user.name}} atualizou o status da atividade para aprovada',
  updateServiceOrderStatus_approved_error:
    '{{log.user.name}} recebeu um erro ao atualizar o status da atividade para aprovada',
  updateServiceOrderStatus_disapproved: '{{log.user.name}} atualizou o status da atividade para reprovada',
  updateServiceOrderStatus_disapproved_error:
    '{{log.user.name}} recebeu um erro ao atualizar o status da atividade para reprovada',
  updateServiceOrderStatus_canceled: '{{log.user.name}} atualizou o status da atividade para cancelada',
  updateServiceOrderStatus_canceled_error:
    '{{log.user.name}} recebeu um erro ao atualizar o status da atividade para cancelada',

  savePlace: '{{log.user.name}} salvou um local/pessoa',
  savePlace_plural: '{{log.user.name}} salvou {{count}} locais/pessoas',
  savePlace_error: '{{log.user.name}} recebeu um erro ao salvar locais/pessoas',
  removePlaces: '{{log.user.name}} removeu alguns locais/pessoas',
  removePlaces_error: '{{log.user.name}} recebeu um erro ao remover alguns locais/pessoas',

  createBucket: '{{log.user.name}} criou o lote de qrcodes: {{log.entity.name}}',
  updateBucket: '{{log.user.name}} atualizou o lote de qrcodes: {{log.entity.name}}',
  createBucket_error: '{{log.user.name}} recebeu um erro ao salvar o lote de qrcodes: {{log.entity.name}}',
  updateBucket_error: '{{log.user.name}} recebeu um erro ao salvar o lote de qrcodes: {{log.entity.name}}',
  removeBuckets: '{{log.user.name}} removeu alguns lotes de qrcodes',
  removeBuckets_error: '{{log.user.name}} recebeu um erro ao remover alguns lotes de qrcodes',

  createSegment: '{{log.user.name}} criou a segmentação: {{log.entity.name}}',
  updateSegment: '{{log.user.name}} atualizou a segmentação: {{log.entity.name}}',
  createSegment_error: '{{log.user.name}} recebeu um erro ao salvar a segmentação: {{log.entity.name}}',
  updateSegment_error: '{{log.user.name}} recebeu um erro ao salvar a segmentação: {{log.entity.name}}',
  removeSegments: '{{log.user.name}} removeu algumas segmentações',
  removeSegments_error: '{{log.user.name}} recebeu um erro ao remover algumas segmentações',

  createForm: '{{log.user.name}} criou o formulário: {{log.entity.name}}',
  updateForm: '{{log.user.name}} atualizou o formulário: {{log.entity.name}}',
  createForm_error: '{{log.user.name}} recebeu um erro ao criar o formulário: {{log.entity.name}}',
  updateForm_error: '{{log.user.name}} recebeu um erro ao atualizar o formulário: {{log.entity.name}}',
  removeForm: '{{log.user.name}} removeu alguns formulários',
  removeForm_error: '{{log.user.name}} recebeu um erro ao remover alguns formulários',
  answerForm: 'Uma nova resposta do form: {{log.entity.name}} foi recebida',
  answerForm_error: 'Ocorreu um erro ao responder o form: {{log.entity.name}}',

  enableModule: '{{log.user.name}} ativou o módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  disableModule: '{{log.user.name}} desativou o módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  updateModule: '{{log.user.name}} atualizou o módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  enableModule_error:
    '{{log.user.name}} recebeu um erro ao ativar o módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  disableModule_error:
    '{{log.user.name}} recebeu um erro ao desativar o módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',
  updateModule_error:
    '{{log.user.name}} recebeu um erro ao atualizar o módulo: {{log.entities.0.name}} | {{log.entities.1.name}}',

  importUser: '{{log.user.name}} solicitou uma importação de usuários',
  importRefund: '{{log.user.name}} solicitou uma importação de reembolsos',
  importPlace: '{{log.user.name}} solicitou uma importação de locais/pessoas',
  importForm: '{{log.user.name}} solicitou uma importação de um formulário',
  importChecklist: '{{log.user.name}} solicitou uma importação de questionários',
  importServiceOrder: '{{log.user.name}} solicitou uma importação de atividades',

  exportUsers: '{{log.user.name}} solicitou uma exportação de usuários',
  exportUser: '$t(exportUser)',
  exportRefunds: '{{log.user.name}} solicitou uma exportação de reembolsos',
  exportRefund: '$t(exportRefunds)',
  exportPlaces: '{{log.user.name}} solicitou uma exportação de locais/pessoas',
  exportPlace: '$t(exportPlaces)',
  exportForm: '{{log.user.name}} solicitou uma exportação de um formulário',
  exportChecklists: '{{log.user.name}} solicitou uma exportação de questionários',
  exportChecklist: '$t(exportChecklists)',
  exportServiceOrders: '{{log.user.name}} solicitou uma exportação de atividades',
  exportServiceOrder: '$t(exportServiceOrders)',

  login: '{{log.user.name}} se logou no {{log.origin}}',
  login_error: 'Email: {{log.entity.name}} não conseguiu se logar no {{log.origin}}',
  logout: '{{log.user.name}} se deslogou no {{log.origin}}',
  forceLogout_warn: '{{log.user.name}} foi forçado a deslogar no {{log.origin}}',
  access: '{{log.user.name}} se acessou no {{log.origin}}',

  addLog_warn: '{{log.user.name}} tentou salvar um log mas falhou',
  apiCall_error:
    '{{log.user.name}} recebeu um erro ao chamar a api: {{log.data.payload.method}} /{{log.data.payload.path}}',

  monitorApiCall: `{{log.user.name}} chamou a api: {{log.data.payload.method}} /{{log.data.payload.path}}`,

  initSync: '{{log.user.name}} iniciou uma sincronização',
  endSync: '{{log.user.name}} finalizou uma sincronização',

  fetchSyncSegment: '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} segmentações pelo sync',
  fetchSyncChecklist: '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} questionários pelo sync',
  fetchSyncPlace: '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} locais/pessoas pelo sync',
  fetchSyncUser: '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} usuários pelo sync',
  fetchSyncStatus: '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} status pelo sync',
  fetchSyncCompany: '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} empresas pelo sync',
  fetchSyncPlaceLevel: '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} níveis de locais pelo sync',
  fetchSyncField:
    '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} configurações de campos adicionais pelo sync',
  fetchSyncServiceOrder: '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} atividades pelo sync',
  fetchSyncLevel:
    '{{log.user.name}} recebeu {{log.data.response.result.rowsLength}} configuração de níveis de locais pelo sync',
  requestSyncServiceOrder: '{{log.user.name}} enviou uma atividade pelo sync',
  requestSyncReply: '{{log.user.name}} enviou as respostas de uma atividade pelo sync',
  requestSyncEvent: '{{log.user.name}} enviou os eventos de uma atividade pelo sync',
  clearDB_warn: '{{log.user.name}} apagou todos os dados do app mobile',
  clearSyncPending_warn: '{{log.user.name}} forçou remover todas as pendências de sync',

  saved: 'salvo',
  stacktrace: 'Stacktrace'
}
